module.exports = __webpack_public_path__ + "img/LOGO_SVG.dcbed616.svg";